import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['layer']

  connect () {
    this.query = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)')
    this.onMove = (event) => this.#move(event)
    this.onLeave = () => this.#reset()
    this.onQuery = () => {
      if (this.query.matches) return
      this.#reset()
      this.layerTargets.forEach((layer) => this.#clearStyle(layer, 'willChange'))
    }
    this.onTransitionEnd = (event) => this.#settle(event)
    this.element.addEventListener('pointermove', this.onMove)
    this.element.addEventListener('pointerleave', this.onLeave)
    this.element.addEventListener('transitionend', this.onTransitionEnd)
    this.query.addEventListener('change', this.onQuery)
  }

  disconnect () {
    this.element.removeEventListener('pointermove', this.onMove)
    this.element.removeEventListener('pointerleave', this.onLeave)
    this.element.removeEventListener('transitionend', this.onTransitionEnd)
    this.query.removeEventListener('change', this.onQuery)
    window.cancelAnimationFrame(this.frame)
    this.frame = null
    this.layerTargets.forEach((layer) => this.#clearStyle(layer, 'transform', 'willChange'))
  }

  #move (event) {
    if (!this.query.matches || event.pointerType !== 'mouse') return

    this.pointer = [event.clientX, event.clientY]
    this.frame ||= window.requestAnimationFrame(() => {
      this.frame = null
      const box = this.element.getBoundingClientRect()
      const [x, y] = this.pointer
      this.#apply(((x - box.left) / box.width - 0.5) * 2, ((y - box.top) / box.height - 0.5) * 2)
    })
  }

  #reset () {
    window.cancelAnimationFrame(this.frame)
    this.frame = null
    this.layerTargets.forEach((layer) => this.#clearStyle(layer, 'transform'))
  }

  #apply (x, y) {
    this.layerTargets.forEach((layer) => {
      const depth = Number(layer.dataset.parallaxDepth) || 0
      layer.style.willChange = 'transform'
      layer.style.transform = `translate3d(${(x * depth).toFixed(2)}px, ${(y * depth).toFixed(2)}px, 0)`
    })
  }

  #settle (event) {
    const layer = event.target
    if (event.propertyName === 'transform' && this.layerTargets.includes(layer) && !layer.style.transform) {
      this.#clearStyle(layer, 'willChange')
    }
  }

  #clearStyle (layer, ...properties) {
    properties.forEach((property) => { layer.style[property] = '' })
    if (!layer.style.length) layer.removeAttribute('style')
  }
}
